import { render } from "./LandingPageBackground.vue?vue&type=template&id=b2a3af64&scoped=true"
const script = {}

import "./LandingPageBackground.vue?vue&type=style&index=0&id=b2a3af64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a3af64"]])

export default __exports__